import React from 'react';

const checkbox = ({ id, attributes, value, label, onChange }) => {

    const readOnlyAttr = attributes == undefined ? { disabled: 'disabled' } : (attributes.readOnly ? { disabled: 'disabled' } : {});

    return (
        <div className="custom-control custom-checkbox custom-control-inline" style={{ zIndex: '0' }}>
            <input type="checkbox" class="custom-control-input" name={id} id={id} checked={value} onChange={onChange} {...readOnlyAttr} />
            <label class="custom-control-label" htmlFor={id}> {label} </label>
        </div>
    );
};

export default checkbox;